/**
 * assistant · 助手形象（昵称 + 头像字符）
 * ------------------------------------------------------------
 * 设置中心「助手偏好」维护；聊天页助理消息头据此覆盖默认角色名与首字头像。
 * 与「我的」签名、工作偏好共用 localStorage `ema.profile.v1`，merge 写入防覆盖；
 * 留空即回落按意图推导的默认助手（企管助手 / 供应链执行助理）。
 * M2 同步 AI 服务后随账号全局生效。
 */
import { reactive } from 'vue'

const PREF_KEY = 'ema.profile.v1'

export const ASSISTANT_AVATAR_PRESETS = ['✦', '🤖', '🦉', '🐋', '⚡', '🍀', '🛰️', '🐯']

function loadRaw(): Record<string, unknown> {
  try { return JSON.parse(localStorage.getItem(PREF_KEY) || '{}') || {} } catch { return {} }
}

function load(): { name: string; av: string } {
  const a = loadRaw().assistant
  if (!a || typeof a !== 'object') return { name: '', av: '' }
  const { name, av } = a as { name?: unknown; av?: unknown }
  return {
    name: typeof name === 'string' ? name : '',
    av: typeof av === 'string' ? av : ''
  }
}

/** 当前助手形象；name / av 为空字符串表示未自定义，展示端回落默认 */
export const assistantProfile = reactive(load())

function persist() {
  localStorage.setItem(PREF_KEY, JSON.stringify({
    ...loadRaw(),
    assistant: { name: assistantProfile.name, av: assistantProfile.av }
  }))
}

/** 设置助手昵称（trim 后为空则清除自定义，回落默认名） */
export function setAssistantName(name: string) {
  assistantProfile.name = name.trim().slice(0, 12)
  persist()
}

/** 设置助手头像字符（emoji 或单字；为空则清除自定义，回落默认首字） */
export function setAssistantAvatar(av: string) {
  assistantProfile.av = [...av.trim()].slice(0, 2).join('')
  persist()
}
